module.exports = __webpack_public_path__ + "static/git-rebase-v-merge-5-6b047cc0fb2a516b5dad613d7d4d927b.png";